export default "__VITE_ASSET__BAUZAvpP__"